import { render, staticRenderFns } from "./OrgInput.vue?vue&type=template&id=65ce337f"
import script from "./OrgInput.vue?vue&type=script&lang=js"
export * from "./OrgInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports